import React, { Component } from 'react';
import SelectionBox from './SelectionBox';
import ScoreSlider from './Slider/ScoreSlider';
import './ScoreBox.css';

export default class ScoreBox extends Component {
    constructor(props) {
        super(props);
        // this.handleSelectionBoxChange = this.handleSelectionBoxChange.bind(this);
        // this.handleScoreSliderChange = this.handleScoreSliderChange.bind(this);

        let disabled = true;
        let value = [0, 10];
        let index = 0;
        if (this.props.data) {
            disabled = this.props.data.disabled; 
            value = this.props.data.value;
            index = this.props.index;
        }
        this.state = {
            disabled,
            value,
            index
        }
    }
    handleSelectionBoxChange = (name, value, ischecked) => {
        this.setState({ disabled: !ischecked });
        this.props.onScoreBoxChange(this.state.index, !ischecked, this.state.value);
    }
    handleScoreSliderChange = (value) => {
        this.setState({ value });
        this.props.onScoreBoxChange(this.state.index, this.state.disabled, value);
    }
    render() {
        return (
            <div className="ScoreBox">
                <SelectionBox label={this.props.label} name={this.props.name} tooltip={this.props.tooltip} onChange={this.handleSelectionBoxChange} ischecked={!this.state.disabled} />
                <ScoreSlider disabled={this.state.disabled} value={this.state.value} onChange={this.handleScoreSliderChange} />
            </div>
        )
    }
}